import React from 'react'
import "./ButtonComp.css"

const ButtonComp = (props) => {
    let { theme, text, icon, img, onClick, htmlType, style, isDisabled, toggle,textStrong } = props;
    return (
        <button disabled={theme == 'gray' ? true : false} style={style} onClick={onClick} className={`dflex alignCenter justifySB gap20 ${theme === "blue" ? "btnBlue" : theme === "white" ? "btnWhite" : theme === "red" ? "btnRed" : theme === "gray" ? "btnGrey" : ""}`}>{text}<span style={{ fontWeight: 'bold', marginLeft: "-16px" }}>{textStrong}</span >{icon ? <>{icon}</> : img ? <img style={{ width: "20px" }} src={require(`../../Assets/img/${img}.png`)} htmlType={htmlType} /> : <></>} </button>
    )
};

export default ButtonComp;